import {useContext, useCallback} from 'react';
import {
  Visibility,
  WidgetProvider,
  WidgetAPI,
} from '@stripe-internal/conversations-ui';
import {ConfigContext} from './ConfigProvider';
import {useRequestAction} from '../useRequestAction';

type Props = {
  initialVisibility?: Visibility;
  children: JSX.Element;
};

export const AppWidgetProvider = ({initialVisibility, children}: Props) => {
  const config = useContext(ConfigContext);
  const {audience, entrypoint: entryPoint, parentOrigin} = config;
  const requestAction = useRequestAction();

  const actionHandler = useCallback<WidgetAPI['requestAction']>(
    (action, opts) => requestAction({name: 'request-action', action, ...opts}),
    [requestAction],
  );

  return (
    <WidgetProvider
      initialVisibility={initialVisibility}
      audience={audience}
      entryPoint={entryPoint}
      parentOrigin={parentOrigin}
      actionHandler={actionHandler}
    >
      {children}
    </WidgetProvider>
  );
};
